import {ROOT_MODAL} from './types';

export const getRootModal = data => ({
  type: ROOT_MODAL,
  payload: data,
});
